firebird.factory('videoPlayService', [
    '$timeout',
    '$window',
    'logService',
    'connectivityService',
    'analyticsWrapperService',
    'localizationService',
    'videoGlobalService',
    'configService',
    function (
        $timeout,
        $window,
        logService,
        connectivityService,
        analyticsWrapperService,
        localizationService,
        videoGlobalService,
        configService
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoPlayService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // list of play/subscribed feeds for this participants
            self.feeds = {};

            self.initPlay = initPlay;
            self.onVideoPlayMuted = onVideoPlayMuted;
            self.startVideoPlay = startVideoPlay;
            self.stopVideoPlay = stopVideoPlay;
            self.restartVideoPlay = restartVideoPlay;
            self.pauseVideoPlay = pauseVideoPlay;
            self.pauseVideo = pauseVideo;
            self.handleVideoPlayPluginError = handleVideoPlayPluginError;

            // on no-such-feed, it reattempts a sync after 4s. ANYAM-105161. How does it interact with jumpingWorkaround?
            self.resyncAfterNoSuchFeed = true;
            self.resyncAfterNoSuchFeedTimeout = 4000;
            self.resyncAfterNoSuchFeedTimer = null;
            self.stopResyncAfterNoSuchFeedTimer = stopResyncAfterNoSuchFeedTimer;
            self.startResyncAfterNoSuchFeedTimer = startResyncAfterNoSuchFeedTimer;

            self.checkPlayPluginAndRestart = false; // apply extra checks for plugin, and fix willRestart.
            self.restartPlayTimers = {}; // index is fid, value is timer
            self.restartPlayTimeout = 8000;
        }

        function initPlay() {
            const restartPlayTimeout = configService.getValue('restartPlayTimeout');
            if (restartPlayTimeout) {
                self.restartPlayTimeout = parseInt(restartPlayTimeout) || 8000; // use default if set as invalid.
                logger.log('initPlay', `setting restartPlayTimeout to ${self.restartPlayTimeout}`);
            }

            const checkPlayPluginAndRestart = configService.getValue('checkPlayPluginAndRestart');
            if (checkPlayPluginAndRestart) {
                self.checkPlayPluginAndRestart = checkPlayPluginAndRestart !== 'false';
                logger.log('initPlay', `setting checkPlayPluginAndRestart to ${self.checkPlayPluginAndRestart}`);
            } else if (self.simulcastToggleConfig.enabled) {
                self.checkPlayPluginAndRestart = true;
                logger.log('initPlay', `setting checkPlayPluginAndRestart to true due to enableSimulcastToggle`);
            }
        }

        // when mute or unmute event is triggered on a playing video element.
        function onVideoPlayMuted(id, remoteFeed, div, isMute, is_screen) {
            logService.log('videoroomCtrl videoroom subscriber ' + id + ', event ' + (isMute ? 'mute' : 'unmute'));
            div.setAttribute('playing', !isMute);
            remoteFeed.state.playing = !isMute;
            var disabled = div && div.getAttribute('enable') === 'false';
            self.setVideoStatsPlaying(id, div, !isMute, undefined, disabled);
            if (self.videocodec == 'h264') {
                // TODO: we should remove h264 check
                self.checkMuteToFIR(id, remoteFeed, isMute, disabled);
            }

            // re-do previously pending simulcast requests.
            if (!isMute && div.pendingSimulcast) {
                var data = div.pendingSimulcast;
                delete div.pendingSimulcast;
                logService.log('videoroomCtrl videoroom subscriber, redo previously pending simulcast for feed ' + id);
                self.simulcastReason = 'onVideoPlayMuted apply pendingSimulcast on unmute';
                self.setSimulcast(div, data[0], data[1], data[2]);
            }
        }

        // When a remote feed is to removed, detach the plugin handle.
        // If will_restart is set, then it set the remoteFeed.willRestart, which causes
        // the cleanup function to not remove the video element display.
        function stopVideoPlay(id, is_screen, will_restart) {
            var args = [id, is_screen, will_restart]; // save for later use

            if (typeof id === 'string' && id.match(/^\d+$/)) {
                id = parseInt(id);
            }
            // if other publishers left, then remove the video elements for them.
            if (is_screen) {
                id = self.getScreenshareIdFromAttendantId(id);
            }

            self.setVideoStatsAddRemove(id);

            if (self.layoutPage && self.mediapath != 'sfu' && self.onLayoutPageJumpingWorkaround(true, '' + id, args)) {
                return;
            }

            logService.log(
                'videoroomCtrl videoroom subscriber stop id=' +
                    id +
                    ', is_screen=' +
                    is_screen +
                    ', will_restart=' +
                    will_restart
            );

            if (self.mediapath === 'sfu') {
                self.onMediaPathStopPlay(id);
            }

            var remoteFeed = self.feeds[id] || null;
            if (remoteFeed != null) {
                if (remoteFeed === true) {
                    delete self.feeds[id];
                } else {
                    logService.log(
                        'videoroomCtrl videoroom feed ' +
                            id +
                            ' (' +
                            remoteFeed.rfdisplay +
                            ') has left the room, detaching'
                    );

                    if (!self.checkPlayPluginAndRestart) {
                        if (will_restart) {
                            remoteFeed.willRestart = true;
                        }
                    } else {
                        if (will_restart === true) {
                            remoteFeed.willRestart = true;
                        } else if (will_restart === false) {
                            remoteFeed.willRestart = false;
                        }
                    }

                    delete self.feeds[id];

                    if (self.videocodec == 'h264') {
                        self.removeMuteToFIR(remoteFeed);
                    }
                    self.detachPlugin(remoteFeed);

                    if (remoteFeed._bitrateLow) {
                        delete remoteFeed._bitrateLow;
                    }
                    if (remoteFeed._bitrateLowTimer) {
                        $timeout.cancel(remoteFeed._bitrateLowTimer);
                        delete remoteFeed._bitrateLowTimer;
                    }
                }
            }

            if (
                (!self.checkPlayPluginAndRestart && remoteFeed && !will_restart) ||
                (self.checkPlayPluginAndRestart &&
                    remoteFeed &&
                    (will_restart === false || (will_restart === undefined && remoteFeed.willRestart !== true)))
            ) {
                self.removeVideoElement(id);
                if (remoteFeed !== true) {
                    remoteFeed.state.video = false;
                }
            }
        }

        // When a new remote video feed is detected in the video room, then create a new remote feed
        // plugin handle to attach to the same video room plugin, to subscribe and display the remote video
        // feed. All the events and messages for this remote feed is also processed here.
        // The enabled parameter is useful only for mediapath of 'sfu', and is assumed true otherwise.
        function startVideoPlay(id, is_screen, enabled) {
            if (connectivityService.getIsPhoneOnly()) {
                logService.log('videoroomCtrl phone only mode... returning from startVideoPlay');
                return;
            }

            if (!self.janus || !self.janus.isConnected()) {
                logService.log(
                    'videoroomCtrl videoroom subscriber postponing attach plugin as not yet connected id=' + id
                );
                return;
            }

            var args = [id, is_screen, enabled]; // save for use later.

            if (self.mediapath != 'sfu') {
                enabled = true;
            }

            var fidSuffix = ''; // this is used for testvideos case.
            if (self.testvideos && typeof id === 'string') {
                rindex = id.lastIndexOf(':');
                if (rindex >= 0) {
                    fidSuffix = id.substring(rindex + 1);
                    id = parseInt(id.substring(0, rindex));
                }
            }

            if (typeof id === 'string' && id.match(/^\d+$/)) {
                id = parseInt(id);
            }

            if (is_screen) {
                id = self.getScreenshareIdFromAttendantId(id);
            } else {
                // if id was supplied as screen share id (not attendant id), and is_screen was false.
                is_screen = self.isScreenshareId(id);
            }

            var publisherId = self.getPublisherIdFromFeedId(id, is_screen);

            if (
                (typeof publisherId === 'string' && !publisherId.match(/^\d+$/)) ||
                (typeof publisherId === 'number' && isNaN(publisherId))
            ) {
                logger.warn('startVideoPlay', 'videoroom subscriber failed to use non-numeric id', publisherId);
                return;
            }

            var remoteFeed = null;
            var fid = id; // feed index - can be integer or string

            if (fidSuffix) {
                fid = '' + fid + ':' + fidSuffix; // is string now.
            }

            // capture this flag before the async attach function.
            var isScreenVideo = !!(
                self.multishare &&
                is_screen &&
                self.getAttendantIdFromScreenshareId(id) != self.screenshareOwner
            );

            if (self.layoutPage && self.mediapath != 'sfu' && self.onLayoutPageJumpingWorkaround(false, fid, args)) {
                return;
            }

            logService.log('videoroomCtrl videoroom subscriber start fid=' + fid + ' screen=' + is_screen);

            if (self.mediapath === 'sfu') {
                self.onMediaPathStartPlay(fid);
            }

            if (self.feeds[fid]) {
                logger.warn('startVideoPlay', 'videoroom subscriber already active, will overwrite, for id=' + fid);
            }

            self.feeds[fid] = true; // this just means that it is being initialized, to avoid double creation
            self.onLayoutPageSubscriberCreate(
                {
                    plugin: self.newplugin ? 'janus.plugin.anymeeting' : 'janus.plugin.videoroom',
                    handle_type: 'videoroom',
                    opaqueId: self.opaqueId,
                    success: function (pluginHandle) {
                        // Join the video room as a subscriber. Supply the id of the publisher (and private id too).
                        remoteFeed = pluginHandle;
                        remoteFeed.feedId = fid;
                        remoteFeed.isScreen = is_screen;
                        remoteFeed.simulcastStarted = false;

                        logService.log(
                            'videoroomCtrl videoroom subscriber plugin attached! (' +
                                remoteFeed.getPlugin() +
                                ', id=' +
                                fid +
                                ', feed=' +
                                publisherId +
                                ')'
                        );

                        remoteFeed.state = {};
                        remoteFeed.state.call = 'starting';

                        var subscribe = { request: 'join', room: self.myroom, ptype: 'subscriber', feed: publisherId };
                        self.addPinToRequest(subscribe);

                        if (self.simulcastAt < self.simulcastAtMax) {
                            // so that it starts with best substream, and may switch to other substream later
                            subscribe.spatial_layer = subscribe.substream = 2;
                            subscribe.temporal_layer = subscribe.temporal = 2;
                            if (self.layoutPage && self.layoutPageData.layout == 'allhands') {
                                // except for page view, which starts with lowest.
                                subscribe.spatial_layer = subscribe.substream = 0;
                                subscribe.temporal_layer = subscribe.temporal = 0;
                            }
                        }
                        sendToVideoPlayPlugin(remoteFeed, { message: subscribe });
                    },
                    error: function (error) {
                        logger.error(
                            'startVideoPlay->onLayoutPageSubscriberCreate.error',
                            'videoroom subscriber error attaching plugin...',
                            error
                        );
                        delete self.feeds[fid];

                        if (self.shouldReattachPluginAfterError(error)) {
                            $timeout(() => self.startVideoPlay(id, is_screen, enabled), 0);

                            // videoConnectService.coreError will not be called
                            return true;
                        }

                        return false;
                    },
                    onmessage: function (msg, jsep) {
                        // TODO sbelikov discuss with Kundan: what if invalidPlugin for message?
                        let invalidPlugin = false;
                        if (self.checkPlayPluginAndRestart) {
                            const plugin0 = self.feeds[fid];
                            if (!plugin0 || remoteFeed !== plugin0) {
                                logger.warn(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.onmessage',
                                    `plugin is different from feeds ${fid}`
                                );
                                invalidPlugin = true;
                            }
                        }

                        if (msg.error) {
                            if (msg.error_code === 428) {
                                // No such feed
                                logger.warn(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.onmessage',
                                    'videoroom subscriber error message',
                                    msg
                                );
                            } else {
                                logger.error(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.onmessage',
                                    'videoroom subscriber error message',
                                    msg
                                );
                            }

                            if (!invalidPlugin && !self.handleVideoPlayPluginError(msg, remoteFeed)) {
                                return;
                            }
                        } else {
                            logger.log(
                                'startVideoPlay->onLayoutPageSubscriberCreate.onmessage',
                                'received message',
                                msg
                            );

                            var event = msg.anymeeting || msg.videoroom || msg.sip;
                            if (event) {
                                if (event === 'attached') {
                                    // When the plugin is attached, update the id.
                                    if (!self.feeds[fid]) {
                                        // video play was stopped before plugin could be attached.
                                        self.detachPlugin(remoteFeed);
                                        return;
                                    } else if (self.feeds[fid] !== true && self.feeds[fid] !== remoteFeed) {
                                        // if restart-video-play was triggered immediately, it may cause duplicate plugin handles.
                                        // remove any previously created plugin handle and peer connection.
                                        logger.warn(
                                            'startVideoPlay->onLayoutPageSubscriberCreate.onmessage',
                                            'videoroom subscribe detaching previous plugin ' +
                                                fid +
                                                ' due to race condition.'
                                        );
                                        self.detachPlugin(self.feeds[fid]);
                                    }

                                    self.feeds[fid] = remoteFeed;
                                    // TODO: need to get rid of rfid in the future
                                    remoteFeed.rfid = msg.id;
                                    remoteFeed.rfdisplay = msg.display;
                                    remoteFeed.state.call = 'attached';
                                    logService.log(
                                        'videoroomCtrl videoroom subscribe attached to feed ' +
                                            remoteFeed.rfid +
                                            ' (' +
                                            remoteFeed.rfdisplay +
                                            ') in room ' +
                                            msg.room
                                    );
                                } else if (event == 'event') {
                                    // when a simulcast message is received, mark the remote feed as simulcast enabled.
                                    if (
                                        msg.substream !== undefined ||
                                        msg.temporal !== undefined ||
                                        msg.spatial_layer !== undefined ||
                                        msg.temporal_layer !== undefined
                                    ) {
                                        if (!remoteFeed.simulcastStarted) {
                                            remoteFeed.simulcastStarted = true;
                                        }
                                        var div = $window.$('#videoroom-videos div[user="' + fid + '"]');
                                        if (msg.substream !== undefined) {
                                            div.attr('substream', msg.substream);
                                            logService.log(
                                                `videoroomCtrl videoroom subscriber[${div.attr(
                                                    'user'
                                                )}] switched simulcast substream=${msg.substream}`
                                            );
                                        } else if (msg.spatial_layer !== undefined) {
                                            div.attr('substream', msg.spatial_layer);
                                            logService.log(
                                                `videoroomCtrl videoroom subscriber[${div.attr(
                                                    'user'
                                                )}] switched simulcast spatial_layer=${msg.spatial_layer}`
                                            );
                                        }
                                        if (msg.temporal !== undefined) {
                                            div.attr('temporal', msg.temporal);
                                            logService.log(
                                                `videoroomCtrl videoroom subscriber[${div.attr(
                                                    'user'
                                                )}] switched simulcast temporal=${msg.temporal}`
                                            );
                                        } else if (msg.temporal_layer !== undefined) {
                                            div.attr('temporal', msg.temporal_layer);
                                            logService.log(
                                                `videoroomCtrl videoroom subscriber[${div.attr(
                                                    'user'
                                                )}] switched simulcast temporal_layer=${msg.temporal_layer}`
                                            );
                                        }

                                        var actual =
                                            msg.substream !== undefined
                                                ? msg.substream
                                                : msg.spatial_layer !== undefined
                                                ? msg.spatial_layer
                                                : undefined;
                                        if (actual !== undefined && !self.simulcastToggleState.restricted) {
                                            self.verifySimulcastLater2(div.get(0), actual);
                                        }
                                    }

                                    if (
                                        (self.videoToggle || self.videoLoss || self.layoutPage) &&
                                        msg.started == 'ok'
                                    ) {
                                        // pause it if needed.
                                        if (
                                            (self.layoutPage && remoteFeed.layoutHidden) ||
                                            (self.videoToggle && self.isVideoTogglePaused(is_screen)) ||
                                            $window.$('#videoroom-videos div[user="' + fid + '"]').attr('paused') ==
                                                'true'
                                        ) {
                                            if (self.mediapath === 'sfu') {
                                                sendToVideoPlayPlugin(remoteFeed, {
                                                    message: { request: 'configure', audio: true, video: false }
                                                });
                                            } else {
                                                self.pauseVideoPlay(remoteFeed, true);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        if (jsep) {
                            handleVideoPlayJSEP(jsep, remoteFeed);
                        }
                    },
                    webrtcState: function (on, reason) {
                        logService.log(
                            'videoroomCtrl videoroom subscriber says this WebRTC PeerConnection (feed #' +
                                remoteFeed.rfid +
                                ') is ' +
                                (on ? 'up' : 'down') +
                                ' now, reason=' +
                                reason
                        );

                        remoteFeed.state.webrtc = !!on;
                        self.sendStatsUpdate(on, remoteFeed);
                    },
                    iceState: function (state) {
                        logService.log('videoroomCtrl videoroom subscriber ' + fid + ' iceState ' + state);

                        remoteFeed.state.ice = state;

                        if (state == 'disconnected') {
                            if (self.videocodec == 'h264') {
                                self.removeMuteToFIR(remoteFeed);
                            }
                            self.iceRestartAfter(remoteFeed, 'video-receive', fid);

                            if (Object.keys(self.feeds).length === 0) {
                                self.cancelSfuReceivedVideoStreamsInterval();
                            }
                        } else if (state == 'connected') {
                            if (remoteFeed) {
                                self.iceRestartCancel(remoteFeed);
                            }
                            if (remoteFeed && remoteFeed.webrtcStuff) {
                                logService.log(
                                    'videoroomCtrl applying getStats to incoming video peer connection:',
                                    fid
                                );
                                self.applyGetStats(
                                    remoteFeed.webrtcStuff.pc,
                                    connectivityService.callMediaTypes.SFU_RECEIVED_VIDEO,
                                    { transmissionType: 'received', mediaType: 'video' },
                                    id
                                );

                                if (!self.sfuReceivedVideoStreamsInterval) {
                                    self.startSfuReceivedVideoStreamsInterval();
                                }
                            }
                        }
                    },
                    slowLink: function (uplink, lost) {
                        if (self.checkPlayPluginAndRestart) {
                            const plugin0 = self.feeds[fid];
                            if (!plugin0 || remoteFeed !== plugin0) {
                                logger.warn(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.slowLink',
                                    `plugin is different from feeds ${fid}`
                                );
                                return;
                            }
                        }

                        if (uplink) {
                            self.onSlowLink('video', false, lost, fid);
                        }
                    },
                    onlocalstream: function (stream) {
                        // The subscriber stream is recvonly, we don't expect anything here
                    },
                    onremotestream: function (stream) {
                        // Attach the remote video stream to a new video element for this remote feed.

                        logService.log('videoroomCtrl videoroom subscriber feed #' + remoteFeed.rfid);

                        if (self.checkPlayPluginAndRestart) {
                            const plugin0 = self.feeds[fid];
                            if (!plugin0 || remoteFeed !== plugin0) {
                                logger.warn(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.onremotestream',
                                    `plugin is different from feeds ${fid}`
                                );
                                return;
                            }
                        }

                        var div = self.createVideoElement(
                            enabled,
                            stream,
                            fid,
                            is_screen,
                            undefined,
                            undefined,
                            self.layoutPage,
                            isScreenVideo
                        );
                        div.remoteFeed = remoteFeed;

                        if (self.layoutPage) {
                            // delay updateVideosLayout after remoteFeed is set, so that onLayoutPageSubscriberChange works.
                            if (!self.layoutPageData.animateAdd) {
                                self.disableAnimationOnAllVideos(function () {
                                    self.updateVideosLayout();
                                });
                            } else {
                                self.updateVideosLayout();
                            }
                        }

                        // If the remote feed is a screen feed, and no other video is full size,
                        // then mark this feed as full size video, and update the layout.

                        if (is_screen) {
                            // TODO: hacky way to detect this is a screen share video, and change if not allhands.
                            if (!self.maxvideo || self.talkerLayout == 'auto') {
                                if (!self.layoutPage || self.layoutPageData.layout != 'allhands') {
                                    self.setSpotlightVideo(div);
                                    self.updateVideosLayout();
                                } else {
                                    // layout == "allhands" && self.layoutPage
                                    if (self.layoutPageData.saveSpotlight && self.layoutPageData.savedSpotlight) {
                                        self.layoutPageData.savedSpotlight = null;
                                    }
                                }
                            }

                            self.onScreenVideoMinimized(div, self.screenshareSubState);

                            if (
                                self.layoutLock == 'locked' &&
                                self.getAttendantIdFromScreenshareId(fid) == self.attendantId
                            ) {
                                // displaying self feed.
                                $window.$(div).attr('selfscreen', 'true');
                                $window
                                    .$(div)
                                    .attr(
                                        'data-before-content',
                                        localizationService.translate('SCREENSHARE.YOUR_CONTENT_IS_BEING_SHARED')
                                    );

                                var videoElem = $window.$(div).find('video');
                                // do not use addEventListener or on(...), to keep this re-entrant and avoid need for removeEventListener.
                                if (videoElem.length > 0) {
                                    // ANYAM-73119 - do not show first frame, pause immediately. Keep the old code in case we change our mind.
                                    // TODO: ideally should pause at server to avoid receiving the stream.
                                    if (videoElem[0].pause) {
                                        videoElem[0].pause();
                                    }
                                    // videoElem[0].onplay = function(event) {
                                    //     event.currentTarget.pause();
                                    // };
                                }
                            }
                        } else {
                            if (self.preferredLayout === 'spotlight') {
                                if (!self.maxvideo) {
                                    self.setSpotlightVideo(div);
                                    self.updateVideosLayout();
                                }
                            } else if (self.preferredLayout === 'grid') {
                                if (self.maxvideo) {
                                    self.setSpotlightVideo(null);
                                    self.updateVideosLayout();
                                }
                            } else if (self.preferredLayout === 'allhands' && self.layoutPage) {
                                if (self.maxvideo) {
                                    self.onLayoutPageToggleSpotlight(null, true); // do not set layout here
                                    self.setCurrentLayout('allhands'); // explicitly set to allhands
                                    self.onLayoutPageUpdateLessCutoff('spotlight', 'allhands');
                                    self.updateVideosLayout();
                                }
                            }
                        }

                        remoteFeed.state.video = true;

                        if (self.e2ee) {
                            self.e2eeSetupReceiver(remoteFeed, stream);
                        }

                        var videoTracks = stream && stream.getVideoTracks();
                        if (videoTracks && videoTracks.length > 0) {
                            div.setAttribute('playing', !videoTracks[0].muted);
                            const disabled = div.getAttribute('enable') === 'false';
                            self.setVideoStatsPlaying(fid, div, !videoTracks[0].muted, true, disabled);
                            if (self.layoutPage && self.layoutPageReuse.enabled) {
                                self.layoutPageVideoMuteUnmuteListener(
                                    videoTracks[0],
                                    { div: div, fid: fid },
                                    function (state, event) {
                                        var div = state.div,
                                            fid = state.fid;
                                        self.onVideoPlayMuted(
                                            fid,
                                            div.remoteFeed,
                                            div,
                                            event.type == 'mute',
                                            is_screen
                                        );
                                    }
                                );
                            } else {
                                // TODO: remove if-else and use if-block for both.
                                videoTracks[0].addEventListener('mute', function (event) {
                                    self.onVideoPlayMuted(id, remoteFeed, div, true, is_screen);
                                });
                                videoTracks[0].addEventListener('unmute', function (event) {
                                    self.onVideoPlayMuted(id, remoteFeed, div, false, is_screen);
                                });
                            }
                        }

                        self.createVideoBitrateControl(id, is_screen);
                    },
                    ondetached: function () {
                        logger.warn(
                            'startVideoPlay->onLayoutPageSubscriberCreate.ondetached',
                            'videoroom subscriber, got forced detached from server, we stop video play'
                        );

                        if (self.checkPlayPluginAndRestart) {
                            const plugin0 = self.feeds[fid];
                            if (!plugin0 || remoteFeed !== plugin0) {
                                logger.warn(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.ondetached',
                                    `plugin is different from feeds ${fid}`
                                );
                                return;
                            }

                            if (self.feeds[fid]) {
                                // stopVideoPlay was not yet called.

                                // pause video instead of seeing black video box
                                pauseVideo(fid);

                                remoteFeed.willRestart = true;
                            }
                        }

                        // timeout needed to delay our detach(withRequest) after detach(noRequest) of janus.js to avoid error from server
                        $timeout(function () {
                            self.msgflowEvent('play-stop:detached:' + id, {
                                reason: 'forced detached',
                                id: id,
                                screen: is_screen
                            });
                            self.stopVideoPlay(id, is_screen);
                        }, 0);
                    },
                    oncleanup: function () {
                        // when the remote feed plugin is cleaned up, remove the remote video element.
                        logService.log(
                            'videoroomCtrl videoroom subscriber, got a cleanup notification (remote feed ' +
                                fid +
                                ') :::'
                        );

                        let invalidPlugin = false;
                        if (self.checkPlayPluginAndRestart) {
                            const plugin0 = self.feeds[fid];
                            if (!plugin0 || remoteFeed !== plugin0) {
                                logger.warn(
                                    'startVideoPlay->onLayoutPageSubscriberCreate.oncleanup',
                                    `plugin is different from feeds ${fid}`
                                );
                                invalidPlugin = true;
                            }
                        }

                        var div1 = self.getVideoElement(fid, true);
                        self.cleanupSimulcastTimer(div1);
                        self.setVideoStatsAddRemove(fid);

                        if (self.feeds[fid]) {
                            // stopVideoPlay was not yet called.

                            if (self.checkPlayPluginAndRestart && !invalidPlugin) {
                                // pause video instead of seeing black video box
                                pauseVideo(fid);
                            }

                            remoteFeed.willRestart = true;
                        }

                        if (!remoteFeed.willRestart) {
                            // but do not remove if this is a restart step.
                            if (!invalidPlugin) {
                                self.removeVideoElement(fid);
                            }
                            remoteFeed.state.video = false;
                        }

                        remoteFeed.simulcastStarted = false;
                        self.destroyVideoBitrateControl(id, is_screen);
                        remoteFeed.state.call = 'closed';
                        if (!remoteFeed.willRestart && self.feeds[fid]) {
                            logService.log('videoroomCtrl videoroom subscriber, deleting self.feeds[' + fid + ']');
                            delete self.feeds[fid];
                            self.detachPlugin(remoteFeed);
                        }
                        self.iceRestartCancel(remoteFeed);
                        if (self.videocodec == 'h264') {
                            self.removeMuteToFIR(remoteFeed);
                        }

                        if (remoteFeed.willRestart && !remoteFeed.detaching) {
                            logService.log('videoroomCtrl videoroom subscriber, will restart soon for id=' + fid);

                            cancelRestartPlayTimer(fid);

                            const timer = $timeout(
                                function () {
                                    if (self.checkPlayPluginAndRestart) {
                                        delete self.restartPlayTimers[fid];
                                    }

                                    // if condition does not change even after 8 seconds, attempt to replay this feed.
                                    if (
                                        self.feeds[fid] === remoteFeed &&
                                        remoteFeed.willRestart &&
                                        !remoteFeed.detaching
                                    ) {
                                        logService.log(
                                            'videoroomCtrl videoroom subscriber, restarting video play for id=' + fid
                                        );
                                        self.msgflowEvent('play-restart:timeout', {
                                            reason: 'timeout after cleanup',
                                            id: fid
                                        });
                                        self.restartVideoPlay(fid);
                                    } else {
                                        logService.log(
                                            'videoroomCtrl videoroom subscriber, aborting restart for id=' + fid
                                        );
                                    }
                                },
                                !self.checkPlayPluginAndRestart ? 4000 : self.restartPlayTimeout
                            );

                            if (self.checkPlayPluginAndRestart) {
                                self.restartPlayTimers[fid] = timer;
                            }
                        }
                    }
                },
                { fid: fid, is_screen: is_screen }
            );
        }

        function pauseVideo(fid) {
            if (self.simulcastToggleConfig.enabled && self.simulcastToggleConfig.pauseOnRestart) {
                const videoElement = $window.$(
                    '#videoroom-videos > div.remote[user="' + fid + '"]:not(.audioonly) video'
                )[0];
                if (videoElement && !videoElement.paused && videoElement.pause) {
                    videoElement.pause();
                }
            }
        }

        function cancelRestartPlayTimer(fid) {
            if (self.checkPlayPluginAndRestart && self.restartPlayTimers[fid]) {
                $timeout.cancel(self.restartPlayTimers[fid]);
                delete self.restartPlayTimers[fid];
            }
        }

        function sendToVideoPlayPlugin(remoteFeed, callbacks) {
            if (callbacks.error === undefined) {
                callbacks.error = msg => {
                    logger.error('sendToVideoPlayPlugin', 'initial message', callbacks.message, 'response', msg);
                    self.handleVideoPlayPluginError(msg, remoteFeed);
                };
            }

            if (remoteFeed) {
                remoteFeed.send(callbacks);
            }
        }

        function handleVideoPlayPluginError(msg, remoteFeed) {
            // JANUS_VIDEOROOM_ERROR_INVALID_SDP: handle this error in videoLayoutReuseService
            if (msg.error_code === 437 || ('' + msg.error).indexOf('switch') >= 0) {
                return true;
            }

            const fid = remoteFeed.feedId;

            switch (msg.error_code) {
                case 424: // JANUS_VIDEOROOM_ERROR_JOIN_FIRST
                case 425: // JANUS_VIDEOROOM_ERROR_ALREADY_JOINED
                case 432: // JANUS_VIDEOROOM_ERROR_PUBLISHERS_FULL
                case 433: // JANUS_VIDEOROOM_ERROR_UNAUTHORIZED
                case 434: // JANUS_VIDEOROOM_ERROR_ALREADY_PUBLISHED
                case 435: // JANUS_VIDEOROOM_ERROR_NOT_PUBLISHED
                case 459: // JANUS_ERROR_HANDLE_NOT_FOUND
                case 461: // JANUS_ERROR_PLUGIN_ATTACH
                case 462: // JANUS_ERROR_PLUGIN_MESSAGE (Request prohibitied by AnyMeeting)
                case 466: // JANUS_ERROR_TRICKE_INVALID_STREAM
                case 469: // JANUS_ERROR_UNEXPECTED_ANSWER
                case 471: // JANUS_VIDEOROOM_ERROR_ALREADY_BACKEND
                case 472: // JANUS_VIDEOROOM_ERROR_DIFFERENT_SERVER
                case 473: // JANUS_ERROR_PLUGIN_SESSION_NOT_FOUND
                case 500: // JANUS_ERROR_INTERNAL_ERROR
                case 502: // JANUS_ERROR_BAD_GATEWAY
                case 503: // JANUS_ERROR_SERVICE_UNAVAILABLE
                case 504: // JANUS_ERROR_GATEWAY_TIMEOUT
                    self.restartVideoPlay(fid);
                    return false;
                case 426: // JANUS_VIDEOROOM_ERROR_NO_SUCH_ROOM
                case 428: // JANUS_VIDEOROOM_ERROR_NO_SUCH_FEED
                    // This may be race condition during reconnect from subscriber and publisher both.
                    // retry for now on next attendee list update.
                    // Later the node server will make sure that room exists.
                    if (self.layoutPage && msg.error_code === 428) {
                        self.layoutPageMissingFeed[fid] = Date.now();
                    }

                    if (!self.checkPlayPluginAndRestart) {
                        delete self.feeds[fid];
                        self.detachPlugin(remoteFeed);

                        if (remoteFeed && remoteFeed.willRestart) {
                            // previous cleanup pending, cleanup now, since feed is removed.
                            delete remoteFeed.willRestart;
                            self.removeVideoElement(fid);
                            remoteFeed.state.video = false;
                        }
                    } else {
                        if (self.feeds[fid]) {
                            self.feeds[fid].willRestart = true;
                        }

                        self.detachPlugin(remoteFeed);
                    }

                    if (self.resyncAfterNoSuchFeed && msg.error_code === 428) {
                        self.stopResyncAfterNoSuchFeedTimer();
                        self.startResyncAfterNoSuchFeedTimer();
                        if (self.testvideos) {
                            $timeout(function () {
                                self.testvideosStartPublish(true);
                            }, 1000);
                        }
                    }
                    break;
                case 470: // JANUS_VIDEOROOM_ERROR_ALREADY_DESTROYED
                case 499: // JANUS_VIDEOROOM_ERROR_UNKNOWN_ERROR
                    // TODO: think about to add retry logic in the future (retryWithExponentialBackoffAndLimit)
                    self.prepareForRejoinConference();
                    self.rejoinConferenceAfter(msg.error, 0, undefined, true);
                    return false;
                default:
                    break;
            }

            return true;
        }

        function handleVideoPlayJSEP(jsep, remoteFeed) {
            // If SDP is received, handle the SDP. The server generates the offer,
            // the client then sends the answer. Note that only video receive is enabled
            // for subscribers or remote video feed.
            logger.log('handleVideoPlayJSEP', 'videoroom subscriber handling SDP as well...', jsep);

            remoteFeed.state.call = 'answering';
            self.customizeSdpSubscribe(jsep);

            remoteFeed.createAnswer({
                jsep: jsep,
                media: {
                    audioSend: false,
                    videoSend: false,
                    audioRecv: false,
                    videoRecv: true
                },
                e2ee: !!self.e2ee,
                success: function (jsep) {
                    logger.log(
                        'handleVideoPlayJSEP->remoteFeed.createAnswer->success',
                        'videoroom subscriber got SDP!',
                        jsep
                    );

                    remoteFeed.state.call = 'started';
                    var body = { request: 'start', room: self.myroom };
                    sendToVideoPlayPlugin(remoteFeed, { message: body, jsep: jsep });
                },
                error: function (error) {
                    logger.error(
                        'handleVideoPlayJSEP->remoteFeed.createAnswer->error',
                        'videoroom subscriber WebRTC error',
                        error
                    );
                }
            });
        }

        function stopResyncAfterNoSuchFeedTimer() {
            if (self.resyncAfterNoSuchFeedTimer) {
                $timeout.cancel(self.resyncAfterNoSuchFeedTimer);
                self.resyncAfterNoSuchFeedTimer = null;
            }
        }

        function startResyncAfterNoSuchFeedTimer() {
            self.resyncAfterNoSuchFeedTimer = $timeout(function () {
                self.resyncAfterNoSuchFeedTimer = null;
                self.syncAttendeeListVideoMuteStates();
            }, self.resyncAfterNoSuchFeedTimeout);
        }

        // stop and start a video stream for a publisher, without closing the video element display.
        function restartVideoPlay(attendantId) {
            var exists = false;

            cancelRestartPlayTimer(attendantId);

            if (self.feeds[attendantId]) {
                exists = true;
                self.stopVideoPlay(attendantId, undefined, true);
            }
            if (exists || !self.isScreenshareId(attendantId)) {
                // play participant video even if feeds is empty, but not screen share video.
                // if video was enabled previously, enable it again.
                var enabled; // used only for mediapath of 'sfu'
                if (self.mediapath == 'sfu') {
                    // enabled reflects whether participant is not vmuted.
                    var attendee = self.findAttendee(attendantId);
                    enabled = (attendee && !attendee.isVideoMuted) || false;
                }
                self.startVideoPlay(attendantId, undefined, enabled);
            }
        }

        function pauseVideoPlay(remoteFeed, pause) {
            if (pause) {
                if (!remoteFeed.detaching) {
                    // don't pause if already detaching
                    const webrtcStuff = remoteFeed.webrtcStuff;
                    if (webrtcStuff) {
                        // paused flag need to be in plugin specific structure.
                        webrtcStuff._paused = true;
                    }

                    sendToVideoPlayPlugin(remoteFeed, { message: { request: 'pause' } });
                }
            } else {
                const webrtcStuff = remoteFeed.webrtcStuff;
                if (webrtcStuff) {
                    if (webrtcStuff._paused) {
                        delete webrtcStuff._paused;
                    } else {
                        return; // do not send redundant start if it was not paused previously ANYAM-82437
                    }
                }

                sendToVideoPlayPlugin(remoteFeed, { message: { request: 'start' } });
            }
        }
    }
]);
